import * as React from "react";

const SendFilled: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5 11L21 12L5 13V18.3819C5 19.1253 5.78231 19.6088 6.44721 19.2763L21 12L6.44721 4.72356C5.78231 4.39111 5 4.87461 5 5.61799V11Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(SendFilled);
